import * as types from "./actionTypes";

const initialState = {
  attrs: undefined,
  loading: false,
  error: {
    message: "",
  },
};

const AttributeReducer = (
  state = initialState,
  action: { type: any; payload: any }
) => {
  const actionType = action.type;
  const actionPayload = action.payload;
  switch (actionType) {
    case types.GET_ATTR_DATA:
      state = { ...state, loading: true };
      break;

    case types.GET_ATTR_DATA_SUCCESS:
      state = { ...state, attrs: actionPayload, loading: false };
      break;

    case types.GET_ATTR_DATA_FAIL:
      state = {
        ...state,
        error: {
          message: "Error",
        },
        loading: false,
      };
      break;
  }

  return state;
};

export default AttributeReducer;
